module.exports = __webpack_public_path__ + "static/media/video.5999df98.mp4";